module.exports = __webpack_public_path__ + "img/3.74c59c5b.jpg";